//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'saas_remind',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};